<ng-container *ngIf="initialized">

    <p-accordion [value]="[0]" [multiple]="true">
        <p-accordion-panel [value]="0">
            <p-accordion-header>
                <span class="flex align-items-center gap-2 w-full font-bold">
                    Zuweisung
                </span>
            </p-accordion-header>
            <p-accordion-content>
                <mvs-widget *ngIf="customerInsurableObjectForm"
                            [importObjectContext]="importObjectContext"
                            [widgetData]="customerInsurableObjectForm">

                </mvs-widget>
            </p-accordion-content>

        </p-accordion-panel>

        <p-accordion-panel [value]="1">
            <p-accordion-header >
                <span class="flex align-items-center gap-2 w-full font-bold">
                    Versichertes Objekt/ Risiko
                </span>
            </p-accordion-header>
            <p-accordion-content>
                <mvs-widget *ngIf="insurableObjectForm"
                            [widgetData]="insurableObjectForm"
                            [importObjectContext]="importObjectContext"
                >
                </mvs-widget>
            </p-accordion-content>

        </p-accordion-panel>
    </p-accordion>





</ng-container>